import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NavigateActions } from '../../redux/actions';
import { polyglot } from '../../assets/locales';
import moment from 'moment';
import ROUTES from '../../constants/RouteConstants';
import GeneralUtils from '../../utility/GeneralUtils';
import RICalcStepOne from './RICalcStepOne';
import RICalcStepTwo from './RICalcStepTwo';
import { CalculationUtils, formatter } from '../../utility';
import RICalcStepThree from './RICalcStepThree';
import RICalcStepFour from './RICalcStepFour';
import { GeneratedNoticePhase2 } from '../NoticeGenerator/GeneratedNotice';
import { backIcon } from '../../assets/images';

const RentIncreaseCalculator = (props) => {
  if (!props?.validationData || !Object.keys(props?.validationData)?.length) props.navigate(ROUTES.LANDLORD_VALIDATOR)

  const [p2Data, setData] = useState({});

  const { 
    stepOneSubmitted, stepTwoSubmitted, stepThreeSubmitted, displayGenerateNotice
  } = p2Data;

  useEffect(() => {
    setPreStepOneData();
  },[]);

  const setPreStepOneData = () => {
    if (!props?.validationData) return;

    const { userAccessDate, phase1RentIncreaseDate, rentAmountError, phase1RentAmountUsed, calc_p1MaxAdditionalRentIncrease } = props?.validationData;

    const calc_p2EarliestServiceDate = moment(userAccessDate).startOf('month').add(4, 'months');
    const calc_p2EarliestRentIncreaseDate = moment(phase1RentIncreaseDate).add(1, 'year');
    const calc_p2MaxRentIncreaseDate = moment(phase1RentIncreaseDate).add(2, 'year').subtract(1, 'day');
    const calc_p2MinRentIncreaseDate = calc_p2EarliestServiceDate.isAfter(calc_p2EarliestRentIncreaseDate) ? calc_p2EarliestServiceDate : calc_p2EarliestRentIncreaseDate;
    const calc_p1RentAmount = rentAmountError ? calc_p1MaxAdditionalRentIncrease : phase1RentAmountUsed;
    
    const initP2Data = {
      stepOneSubmitted: false,
      displayGenerateNotice: false,
      calc_p2EarliestServiceDate,
      calc_p2EarliestRentIncreaseDate,
      calc_p2MinRentIncreaseDate,
      calc_p2MaxRentIncreaseDate,
      calc_p1RentAmount,
    }
    
    GeneralUtils.log('----- PRINTING ALL PHASE 2 - PRE STEP 1 CALC VARIABLES -----', 'success');
    GeneralUtils.log(`
      calc_p2EarliestServiceDate: ${formatter.toDateDisplay(calc_p2EarliestServiceDate)}\n
      calc_p2EarliestRentIncreaseDate: ${formatter.toDateDisplay(calc_p2EarliestRentIncreaseDate)}\n
      calc_p2MinRentIncreaseDate: ${formatter.toDateDisplay(calc_p2MinRentIncreaseDate)}\n
      calc_p2MaxRentIncreaseDate: ${formatter.toDateDisplay(calc_p2MaxRentIncreaseDate)}\n
      calc_p1RentAmount: ${calc_p1RentAmount}\n
      `
      , 'info');

    setData(p2Data => ({...p2Data, ...initP2Data }));
  }

  const resetPhaseTwo = () => {
    setData({});
    setTimeout(() => setPreStepOneData(), 100)
  }

  const goBackToPreviousStep = () => {
    props?.navigate(ROUTES.LANDLORD_VALIDATOR);
  }

  const editInformation = () => {
    toggleDisplayGeneratedNotice();
    props.navigate(ROUTES.RENT_INCREASE_CALCULATOR);
  }

  const toggleDisplayGeneratedNotice = () => {
    setData({...p2Data, ...{ displayGenerateNotice: !displayGenerateNotice } })
  }

  const renderPageHeader = () => {
    if (displayGenerateNotice) return;

    return <div className="hide-print">
      <p className="validator__header">Phase 2 Additional Rent Increase Calculation</p>
      <span className="w1-step-one__description">
        The information you entered in the previous step will be used for this process. If any of these values are not correct, you can go&nbsp;
        <span className="ric__link" onClick={() => goBackToPreviousStep()}><img className="ric__link__back-button" src={backIcon} alt="" />&nbsp;back to the previous step</span> and modify these values.
      </span>
    </div>
  }

  return (
    <div className="ric">
      { renderPageHeader() }
      { !displayGenerateNotice && Object.keys(p2Data).length ? <RICalcStepOne phaseOneData={props?.validationData} phaseTwoData={p2Data} setPhaseTwoData={setData} /> : null }
      { !displayGenerateNotice && stepOneSubmitted ? <RICalcStepTwo phaseOneData={props?.validationData} phaseTwoData={p2Data} cpiConfig={props?.cpiConfig} setPhaseTwoData={setData} /> : null }
      { !displayGenerateNotice && stepOneSubmitted && stepTwoSubmitted ? <RICalcStepThree phaseOneData={props?.validationData} phaseTwoData={p2Data} setPhaseTwoData={setData} /> : null }
      { !displayGenerateNotice && stepOneSubmitted && stepTwoSubmitted && stepThreeSubmitted ? <RICalcStepFour phaseTwoData={p2Data} toggleDisplayGeneratedNotice={toggleDisplayGeneratedNotice} resetPhaseTwo={resetPhaseTwo}/> : null }
      { displayGenerateNotice ? <GeneratedNoticePhase2 formData={{...p2Data, ...props?.validationData}} editInformation={editInformation} /> : null }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    cpiConfig: state.config.cpiConfig,
    validationData: state.validations.data,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      navigate: NavigateActions.navigate,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RentIncreaseCalculator);